import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

// Global route gate: if the current user has must_change_password=1, redirect
// every authenticated path (except /change-password + /logout) to the
// change-password screen. The flag is cleared by clearMustChangePassword in
// AuthContext when the endpoint returns 200.
//
// Sits inside <AuthProvider> and wraps the entire <Routes> tree so it runs on
// every location change without per-route boilerplate. Does nothing while auth
// is loading or when the user is unauthenticated — the login flow / public
// routes stay untouched.
//
// Sprint J: bypass the gate during impersonation. The admin shouldn't be
// forced to set the principal's password while previewing the portal.
export default function MustChangePasswordGate({ children }) {
  const { user, mustChangePassword, impersonator, loading } = useAuth();
  const location = useLocation();

  if (loading || !user || !mustChangePassword || impersonator) return children;

  const path = location.pathname;
  // A link from an email sets the password itself, so it must not be redirected away.
  if (path === '/change-password' || path === '/logout' || path === '/set-password') return children;

  return <Navigate to="/change-password" replace />;
}
